import React, { useEffect, useRef, useState } from "react";
import { Avatar, Menu, Spin, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/eye.svg";
import dashboardSvg from "../assets/svg/dashboard.svg";
import flidSvg from "../assets/svg/flid.svg";
import schemeSvg from "../assets/svg/scheme.svg";
import usersSvg from "../assets/svg/svg34.svg";
import irrInstSvg from "../assets/svg/svg39.svg";
import projectsSvg from "../assets/svg/svg42.svg";
import iwuasSvg from "../assets/svg/svg54.svg";
import wtrHarvSvg from "../assets/svg/svg55.svg";
import mntrngSvg from "../assets/svg/svg56.svg";
import wtrInfoSvg from "../assets/svg/svg57.svg";
import ecitizenSvg from "../assets/svg/svg58.svg";
import licenseSvg from "../assets/svg/svg59.svg";
import reportSvg from "../assets/svg/svg60.svg";
import reclamationSvg from "../assets/svg/svg61.svg";
import pathwaySvg from "../assets/svg/svg65.svg";
import setupSvg from "../assets/svg/svg80.svg";
import nialogo from "../assets/img/nia.png";
import nwhsalogo from "../assets/img/NWHA.png";
import { formatImgPath, getColorFromName, getInitials } from "../utils";
import { setOpenKeys } from "../features/global/globalSlice";
import { save, saveFile, uploadFile } from "../features/save/saveSlice";
import toast from "react-hot-toast";
import { EditOutlined } from "@ant-design/icons";
import { fetchCounties, fetchData } from "../features/fetch/fetchSlice";

const icons = {
  gridSvg,
  dashboardSvg,
  flidSvg,
  schemeSvg,
  usersSvg,
  irrInstSvg,
  projectsSvg,
  iwuasSvg,
  wtrHarvSvg,
  mntrngSvg,
  wtrInfoSvg,
  ecitizenSvg,
  licenseSvg,
  reportSvg,
  reclamationSvg,
  pathwaySvg,
  setupSvg,
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export default function SideBarOpen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "auth/counties/getFiltered";
  const { sideMenuCollapsed, menuLoading, menuData, openKeys } = useSelector(
    (state) => state.global
  );

  const { userDetails, counties } = useSelector((state) => state.fetch);
  const { user } = useSelector((state) => state.auth);
  const { uploading } = useSelector((state) => state.save);

  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
  }));
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const [selectedCounty, setSelectedCounty] = useState(
    localStorage.getItem("selectedCounty")
  );

  const [imageSrc, setImageSrc] = useState(
    formatImgPath(
      counties?.[0]?.countyIcon == null
        ? "avatar.png"
        : counties?.[0]?.countyIcon
    )
  );
  const [imageSrcCrump, setImageSrcCrump] = useState(
    formatImgPath(
      data?.[0]?.countyIcon == null ? "avatar.png" : data?.[0]?.countyIcon
    )
  );
  const TruncatedTooltip = ({ text }) => {
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const element = textRef.current;
      if (element) {
        const isOverflowing = element?.scrollWidth > element?.clientWidth;
        setIsTruncated(isOverflowing);
      }
    }, [text]);

    return isTruncated ? (
      <Tooltip title={text}>
        <div
          ref={textRef}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ) : (
      <div
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </div>
    );
  };

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        if (item?.isTitle) {
          return {
            key: item?.dymId,
            label: item?.dymLabel,
            type: "group",
          };
        }
        const iconSrc = icons[item?.dymIcon] || gridSvg;
        return getItem(
          item?.dymLabel?.charAt?.(0)?.toUpperCase() + item?.dymLabel?.slice(1),
          item?.dymLink,
          !isChild ? <img src={iconSrc} alt={item?.dymIcon} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const location = useLocation();
  const currentPath = location.pathname;

  const [lastSelectedKey, setLastSelectedKey] = useState(null);

  const handleNavigation = async (e) => {
    setLastSelectedKey(e.key);
    await navigate(e.key);
  };

  const selectedKeyFromPath = currentPath?.replace("/", "");
  const validKeys = menuData?.map((item) => item?.dymLink);
  const selectedKey = validKeys?.includes(selectedKeyFromPath)
    ? selectedKeyFromPath
    : lastSelectedKey;

  const defaultOpenKeys = items
    .filter((item) => item?.dymLabel === "Dashboard")
    .map((item) => item?.key);

  const defaultSelectedKeys = items
    .filter((item) => item?.dymLabel === "Dashboard")
    .map((item) => item?.key);

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.length ? keys[keys.length - 1] : "";
    dispatch(setOpenKeys(latestOpenKey ? [latestOpenKey] : []));
  };

  useEffect(() => {}, [sideMenuCollapsed]);

  useEffect(() => {
    if (data?.[0]?.countyIcon !== null) {
      setImageSrc(formatImgPath(data?.[0]?.countyIcon ?? "avatar.png"));
    }
  }, [data?.[0]?.countyIcon]);

  useEffect(() => {
    if (data?.[0]?.countyIcon !== null && selectedCounty) {
      setImageSrcCrump(formatImgPath(data?.[0]?.countyIcon ?? "avatar.png"));
    }
  }, [selectedCounty, data?.[0]?.countyIcon]);

  
  const handleImageChange = async (e) => {
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    if (!file) {
      return;
    }
    const res = await dispatch(uploadFile(formData));
    if (res?.payload?.success) {
      const formatted = formatImgPath(res?.payload?.data?.result);
      await setImageSrc(formatted); 
      onFinish(res?.payload?.data?.result);
      await toast.success(res?.payload?.message);
    } else {
      toast.error(res?.payload?.message);
    }
  };
  
  const onFinish = async (fileUrl) => {
    const res = await dispatch(
      save({
        countyId: data?.[0]?.countyId,
        countyIcon: fileUrl,
        url: "auth/counties/save",
      })
    ); 
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchCountyFilteredData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

 
  async function fetchCountyData() {
    await dispatch(fetchCounties());
  }

  async function fetchCountyFilteredData() {
    await dispatch(
      fetchData({
        url: url,
        countyId: data?.[0]?.countyId,
        start: 0,
        limit: null,
      })
    );
  }

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedOrg(localStorage.getItem("selectedOrg"));
      setSelectedCounty(localStorage.getItem("selectedCounty"));
    };

    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []); 
  return (
    <div
      style={{
        borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        position: "fixed",
        top: "50px",
        left: 0,
        height: "calc(100vh - 50px)",
        overflowY: "auto",
        overflowX: "hidden",
        boxShadow: "4px 0px 25px 0px rgba(0, 0, 0, 0.08)",
      }}
      className="lg:flex hidden flex-col max-w-[256px] w-full bg-white pt-[2rem] mr-5 thin-scrollbar"
    >
      {user?.userInstitution === "CIDU" && (
        <div className="flex items-center gap-4 ml-5">
          {uploading ? (
            <Spin className="blu_spin" />
          ) : (
            <div className="relative">
              <Avatar
                className="cursor-pointer"
                size={50}
                style={{
                  backgroundColor: getColorFromName(data?.[0]?.countyName),
                }}
                src={data?.[0]?.countyIcon ? imageSrc : undefined}
              >
                {!data?.[0]?.countyIcon &&
                  getInitials(data?.[0]?.countyName)}
              </Avatar>

              <input
                disabled={uploading}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
          )}

          <div className="flex items-center gap-2">
            <span className="text-[#050505] text-[1rem] font-[600] font-interSans">
              {data?.[0]?.countyName}
            </span>
          </div>
        </div>
      )}

      {selectedOrg === "COUNTY" && selectedCounty != null && (
        <div className="flex items-center gap-4 ml-5">
          {uploading ? (
            <Spin className="blu_spin" />
          ) : (
            <div className="relative">
              <Avatar
                className="cursor-pointer"
                size={50}
                style={{
                  backgroundColor: getColorFromName(data?.[0]?.countyName),
                }}
                src={data?.[0]?.countyIcon ? imageSrcCrump : undefined}
              >
                {!data?.[0]?.countyIcon && getInitials(data?.[0]?.countyName)}
              </Avatar>

              <input
                disabled={uploading}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
          )}

          <div className="flex items-center gap-2">
            <span className="text-[#050505] text-[1rem] font-[600] font-interSans">
              {data?.[0]?.countyName}
            </span>
          </div>
        </div>
      )}

      {selectedOrg != "COUNTY" && (
        <img
          loading="lazy"
          decoding="async"
          src={
            selectedOrg === "NIA"
              ? nialogo
              : selectedOrg === "NWHSA"
              ? nwhsalogo
              : null
          }
        />
      )}

      {items?.length > 0 ? (
        <Menu
          onClick={handleNavigation}
          style={{
            width: 256,
          }}
          className=""
          selectedKeys={selectedKey ? [selectedKey] : []}
          // defaultSelectedKeys={defaultSelectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          mode="inline"
          items={items}
          theme="dark"
          inlineCollapsed={sideMenuCollapsed}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}
